<template>
  <div class="modal fade" id="create_package" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="modal-block-vcenter" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div class="block block-themed block-transparent mb-0">
          <div class="block-header bg-danger">
            <h3 class="block-title"><i class="fa fa-box-open"></i> Create Package</h3>
            <div class="block-options">
              <button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close" @click.prevent="clearData()">
              <i class="fa fa-fw fa-times"></i>
              </button>
            </div>
          </div>
          <transition name="slide-fade">
            <div class="text-center alert-message-top" v-if="errorMsg">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="alert-message alert-danger alert-error-message">{{errorMsg}}</div>
              </div>
            </div>
          </transition>
          <div class="block-content">
            <div class="row">
              <div class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 required">
                <label class="control-label">Tag</label>
                <input v-model="pack.tag" name="tag" v-validate="'required'" data-vv-as="Tag" type="text" class="form-control form-control-alt" placeholder="Tag">
                <p v-if="errors.has('tag')" class="errorMsg">{{ errors.first('tag') }}</p>
              </div>
              <div class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 required">
                <label class="control-label">Select item</label>
                <select id="package-item" placeholder="Select Item.." class="form-control package-select2-dropdown" style="width: 100%;">
                  <option></option>
                  <option v-for="(item, index) in library.items" :key="index" :bind:value="item.Name">{{ item.Name }}</option>
                </select>
                <p v-if="itemError" class="errorMsg">The Item field is required.</p>
              </div>
              <div class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 required">
                <label class="control-label">Room</label>
                <select id="package-room" placeholder="Select Room.." class="form-control package-select2-dropdown" style="width: 100%;">
                  <option></option>
                  <option v-for="(room, index) in library.rooms" :key="index" :bind:value="room.Name">{{ room.Name }}</option>
                </select>
                <p v-if="roomError" class="errorMsg">The Room field is required.</p>
              </div>
              <div class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 required">
                <label class="control-label">Unit Of Measure</label>
                <select id="package-measurement" placeholder="Select Measurement Unit.." class="form-control package-select2-dropdown" style="width: 100%;">
                  <option></option>
                  <option v-for="(unit, index) in library.unitOfMeasurement" :key="index" :bind:value="unit.Name">{{ unit.Name }}</option>
                </select>
                <p v-if="measurementError" class="errorMsg">The Unit Of Measure field is required.</p>
              </div>
              <div class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4">
                <label>Quantity</label>
                <input v-model="pack.quantity" type="number" min="1" onkeypress="return event.charCode >= 48" class="form-control form-control-alt" placeholder="Quantity">
              </div>
              <div class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4">
                <label>Creation Date</label>
                <input type="text" name="date" id="creation-date" v-model="pack.date" class="form-control form-control-alt datepicker">
              </div>
              <div class="form-group col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4 toggle-button">
                <label>Product Requires Remediation?</label>
                <div class="custom-control custom-switch custom-control-inline">
                  <input type="checkbox" v-model="pack.productRequiresRemediation" id="remediation-status" class="custom-control-input">
                  <label class="custom-control-label" for="remediation-status"></label>
                </div>
              </div>
              <div class="form-group col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4 toggle-button">
                <label>Production Has Batch?</label>
                <div class="custom-control custom-switch custom-control-inline">
                  <input type="checkbox" v-model="pack.isProductionBatch" id="production-batch" class="custom-control-input">
                  <label class="custom-control-label" for="production-batch"></label>
                </div>
              </div>
              <transition name="slide-fade">
                <div class="form-group col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4" v-if="pack.isProductionBatch">
                  <label>Production Batch Number</label>
                  <input type="text" v-model="pack.productionBatchNumber" class="form-control form-control-alt" placeholder="Production Batch Number">
                </div>
              </transition>
              <div class="form-group col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 clone-content">
                <div class="form-group clone-buttons">
                  <h4 class="clone-title">Ingredients</h4>
                  <button href="#" title="Click to add" id='facilityIcon' @click="addIngredients()" class="clone btn text-danger" v-scroll-to="{ element:'#pageControll', duration: 3000 }"><i class="fa fa-fw fa-plus-square mr-1"></i>Add</button>
                </div>
                <div v-for="(ingredient, index) in ingredients" :key="index" v-bind:class="[ index == 0  ? 'border-facility block-content cloning-content'  : 'remove-facility border-facility block-content' ]">
                  <div class="row" :key="index">
                    <div v-if="index > 0" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-end">
                      <button href="#" title="Click to delete" @click="removeIngredient(index)" class="clone btn delete-icon text-danger"><i class="fa fa-trash-alt"></i></button>
                    </div>
                    <div class="form-group col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                      <label>Label</label>
                      <select :id="`ingredient-label-${index}`" :data-packId="index" placeholder="Select Label.." class="form-control package-label package-select2-dropdown" style="width: 100%;">
                        <option></option>
                        <option v-for="(ingredient, index) in library.packages" :key="index" :bind:value="ingredient.Label">{{ ingredient.Label }}</option>
                      </select>
                    </div>
                    <div class="form-group col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                      <label>Quantity</label>
                      <input type="number" min="1" onkeypress="return event.charCode >= 48" class="form-control form-control-alt" v-model="ingredient.Quantity" placeholder="Quantity">
                    </div>
                    <div class="form-group col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                      <label>Unit Of Measure</label>
                      <select :id="`measure-unit-${index}`" :data-unitId="index" placeholder="Select Measurement Unit.." class="form-control package-select-box package-select2-dropdown" style="width: 100%;">
                        <option></option>
                        <option v-for="(unit, index) in library.unitOfMeasurement" :key="index" :bind:value="unit.Name">{{ unit.Name }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="pageControll" class="block-content block-content-full text-right border-top button-loader">
            <button type="button" class="btn btn-sm btn-light" data-dismiss="modal" @click.prevent="clearData()">Close</button>
            <button type="button" class="btn btn-sm btn-primary" @click="createPackage" :bind:disabled="showModalLoader">
              <div><i class="fa fa-save mr-1"></i><span>Save</span></div>
              <span class="modal-loader" v-if="showModalLoader">
                <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="15" sizeUnit="px"></hash-loader>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import { mapActions, mapState } from 'vuex';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
import { helper } from '@/helper.js';
import $ from 'jquery';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css';
Vue.use(VeeValidate, VueSpinners);

export default {
  name: 'AddPackage',
  data() {
    return {
      pack: {
        id: 0,
        tag: '',
        room: null,
        item: null,
        quantity: 1,
        unitOfMeasure: null,
        isProductionBatch: false,
        productionBatchNumber: '',
        productRequiresRemediation: false,
        patientLicenseNumber: '',
        date: new Date().toJSON().slice(0,10)
      },
      ingredients: [{Package: '', Quantity: 1, UnitOfMeasure: ''}],
      errorMsg: '',
      itemError: false,
      roomError: false,
      measurementError: false,
      i: 0,
      showModalLoader: false
    };
  },
  computed: {
    ...mapState({
      library: state => state.library
    })
  },
  mounted() {
    let vm = this;
    $('.datepicker').datepicker({ format: 'yyyy-mm-dd', autoclose:true });
    $('#package-room').on('change', function () { vm.pack.room = $(this).val(); vm.roomError = false; } );
    $('#package-item').on('change', function () { vm.pack.item = $(this).val(); vm.itemError = false; } );
    $('#package-measurement').on('change', function () { vm.pack.unitOfMeasure = $(this).val(); vm.measurementError = false; } );
    $('.package-select-box').on('change', function(){
      let index = $(this).attr('data-unitId');
      vm.ingredients[index].UnitOfMeasure = $(this).val();
    });
    $('.package-label').on('change', function(){
      let index = $(this).attr('data-packId');
      vm.ingredients[index].Package = $(this).val();
    });
    $('#creation-date').change(function() { vm.pack.date = $(this).val(); });
  },
  components: {
    HashLoader
  },
  methods: {
    ...mapActions('alert', ['success', 'error', 'clear']),
    createPackage() {
      let vm = this;
      this.$validator.validate().then(valid => {
        if (vm.validate() && valid) {
          vm.showModalLoader = true;
          vm.errorMsg = '';
          helper.sendPostRequest('/packages/create', {
            'Tag': vm.pack.tag,
            'Room': vm.pack.room,
            'Item': vm.pack.item,
            'Quantity': vm.pack.quantity,
            'UnitOfMeasure': vm.pack.unitOfMeasure,
            'IsProductionBatch': vm.pack.isProductionBatch,
            'ProductionBatchNumber': vm.pack.productionBatchNumber,
            'ProductRequiresRemediation': vm.pack.productRequiresRemediation,
            'PatientLicenseNumber': vm.pack.patientLicenseNumber,
            'Ingredients': Object.keys(vm.ingredients).length > 1 || vm.ingredients[0].Package !== '' ? vm.ingredients : [],
            'ActualDate': vm.pack.date
          }).then((data) => {
            if (data.status === 'success') {
              vm.$emit('loadPackage', true);
              jQuery('#create_package').modal('hide');
              vm.triggerMessageModal('#alert_modal');
              vm.showModalLoader = false;
              vm.clearData();
              vm.$emit('showSuccessMsg', data.message);
            } else {
              vm.errorMsg = data.message;
              vm.showModalLoader = false;
            }
          });
        }
      });
    },
    clearData() {
      let vm = this;
      Object.keys(vm.pack).map(function(key){ return vm.pack[key] = ''; });
      this.errorMsg = '';
      this.pack.quantity = 1;
      this.pack.date = new Date().toJSON().slice(0,10);
      $('.package-select2-dropdown').val(null).trigger('change');
      if (vm.ingredients) {
        vm.ingredients.forEach((v, i) => {
          vm.removeIngredient(i);
        });
      }
      $('.datepicker').datepicker('update', vm.pack.date);
      vm.ingredients = [{ Tag: '', Quantity: 1, UnitOfMeasure: ''}];
      this.$validator.reset();
    },
    addIngredients() {
      this.ingredients.push({ Tag: '', Quantity: 1, UnitOfmeasure: ''});
      this.i++;
      let vm = this;
      setTimeout(() => {
        $('#ingredient-label-' + vm.i).select2({
          dropdownParent: $('#ingredient-label-' + vm.i).parent(),
          placeholder: 'Select Lable..'
        });
        $('#ingredient-label-' + vm.i).on('change', function(){
          vm.ingredients[vm.i].Package = $(this).val();
        });
        $('#measure-unit-' + vm.i).select2({
          dropdownParent: $('#measure-unit-' + vm.i).parent(),
          placeholder: 'Select Measurement Unit..'
        });
        $('#measure-unit-' + vm.i).on('change', function(){
          vm.ingredients[vm.i].UnitOfmeasure = $(this).val();
        });
      }, 500);
    },
    removeIngredient(index) {
      this.ingredients.splice(index, 1);
      this.i--;
    },
    validate() {
      if (!this.pack.item) {
        this.itemError = true;
      }

      if (!this.pack.room) {
        this.roomError = true;
      }

      if (!this.pack.unitOfMeasure) {
        this.measurementError = true;
      }

      if (this.itemError || this.roomError || this.measurementError) {
        return false;
      }

      return true;
    }
  }
};
</script>

<style>
.clone-buttons .clone {
  padding-top: 0;
}
.toggle-button .custom-control.custom-switch {
  width: auto;
  float: right;
}
.toggle-button label {
  width: 80%;
  float: left;
}
@media only screen and (min-width: 576px) {
  .custom-control.custom-switch {
    float: right;
  }
  .custom-switch .custom-control-label {
    left: 0;
    padding-left: 2.0rem;
  }
}
</style>


// WEBPACK FOOTER //
// source/components/modals/AddPackage.vue